import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { useLocalStorage } from "./use-local-storage";
import { useNoteUsage } from "./use-note-usage";

const preferencesContext = createContext();

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const usePreferences = () => {
  return useContext(preferencesContext);
};

// Hook
export function useProvidePreferences() {
  // Use our useLocalStorage hook to persist state through a page refresh.
  // Read the recipe for this hook to learn more: usehooks.com/useLocalStorage
  const { totalNotesCreated } = useNoteUsage();

  const [firstTimeTourDisabled, setFirstTimeTourDisabled] =
    useLocalStorage("first-time-tour-disabled", null);

  const [isFindAndReplaceEnabled, setIsFindAndReplaceEnabled] =
    useState(localStorage.getItem("find-replace-enabled") === "true");

  useEffect(() => {
    if (
      firstTimeTourDisabled === null &&
      totalNotesCreated !== undefined &&
      totalNotesCreated < 10
    ) {
      setFirstTimeTourDisabled(false);
    }
  }, [
    firstTimeTourDisabled,
    totalNotesCreated,
    setFirstTimeTourDisabled,
  ]);

  useEffect(() => {
    localStorage.setItem(
      "find-replace-enabled",
      isFindAndReplaceEnabled,
    );
  }, [isFindAndReplaceEnabled]);

  // Return enabled  and setter
  return {
    firstTimeTourDisabled,
    setFirstTimeTourDisabled,
    isFindAndReplaceEnabled,
    setIsFindAndReplaceEnabled,
  };
}

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function PreferencesProvider({ children }) {
  const preferences = useProvidePreferences();

  return (
    <preferencesContext.Provider value={preferences}>
      {children}
    </preferencesContext.Provider>
  );
}
